export default __webpack_public_path__ + "static/sweepstakes-first-1-066546f5cb502f68eccc986727a49f53.jpg";